const TestimonialCard = ({data}) => {
    return (
        <div className={'cursor-pointer lg:ml-8 md:ml-0 sm:ml-8 ml-2 mb-12 w-[90%] lg:w-[350px] lg-h-[200px] h-auto bg-white custom-box-shadow py-6 px-4 text-wrap flex flex-col justify-between relative'}>
            <div className={'text-[10px] font-sinhalaSecondary mb-4'}>
                <p>{data.description1}</p>
                <p className={'w-3/4 text-wrap'}>{data.description2}</p>
            </div>

            <p className={'sm:w-full w-1/2 sm:text-sm text-xs text-text-secondary font-semibold sm:whitespace-nowrap overflow-hidden'}>
                {data.name} <span className={`sm:text-xs text-[10px] ${data.school ? '' : 'hidden'}`}>| {data.school}</span>
            </p>

            <img className={'w-[120px] h-[120px] object-cover absolute bg-gray-300 -bottom-5 -right-5 rounded-full'} src={data.image} alt="avatar"/>
        </div>
    )
}

export default TestimonialCard
